//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'CalendarioTabela',
  components: {
    Confirm,
  },
  props: {
    somenteLeitura: true,
  },
  data() {
    return {
      search: '',
      resources: this.$api.calendario(this.$resource),
      totalPage: 0,
      mesAnoPesquisa: this.moment().format('MM-YYYY'),
      indCancelado: false,
      esperar: false,
      menuMesPesquisa: false,
      evento: {},
      pagination: {},
      headers: [
        { text: this.$t('label.nome', 1), value: 'nome', sortable: false },
        { text: this.$tc('label.tipo', 1), value: 'descricao', sortable: false },
        { text: this.$tc('label.data_inicio', 1), value: 'dataInicio', sortable: false },
        { text: this.$tc('label.data_fim', 1), value: 'dataFim', sortable: false },
        { text: this.$t('label.usuario_criador'), value: 'usuarioCriacao', sortable: false },
        { text: this.$t('label.usuario_alteracao'), value: 'usuarioAlteracao', sortable: false },
        { text: this.$t('label.data_do_cancelamento'), value: 'dataCancelamento', sortable: false },
        { text: this.$t('label.cancelar'), value: 'cancelamento', sortable: false },
      ],
      rules: {
        validDate: value => this.isDataValida(value) || this.$t('message.data_invalida'),
      },
      eventos: [],
    };
  },
  computed: {
    mesPesquisaFormatado: {
      get() {
        return this.mesAnoPesquisa;
      },
      set(newValue) {
        this.mesAnoPesquisa = newValue;
      },
    },
    mesPesquisa: {
      get() {
        return this.moment(this.mesAnoPesquisa, 'MM-YYYY').format('YYYY-MM');
      },
      set(newValue) {
        this.mesAnoPesquisa = this.moment(newValue, 'YYYY-MM').format('MM-YYYY');
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    mesAnoPesquisa() {
      this.filtrar();
    },
  },
  methods: {
    cancelarEvento() {
      const params = {
        id: this.evento.id,
      };
      this.resources.cancelar({ id: this.evento.id }, params).then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        this.esperar = true;
        setTimeout(() => {
          this.buscar();
        }, 5E2);
      }, (err) => {
        this.cancelarAlteracaoStatus();
        this.$error(this, err);
      });
    },
    dataFimMaiorQueDataAtual(item) {
      if (item && item.dataFim) {
        return this.moment(item.dataFim, 'DD/MM/YYYY').isAfter(this.moment(), 'day')
                || this.moment(item.dataFim, 'DD/MM/YYYY').isSame(this.moment(), 'day');
      }
      return false;
    },
    cancelarItem(evento) {
      this.evento = evento;
      this.$refs.cancelDialog.open();
    },
    isDataValida(value) {
      return (!value || (value.length === 7 && this.moment(value, 'MM-YYYY').isValid()));
    },
    convertDate(data) {
      return this.moment(data, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    },
    ativarInativa(evento) {
      this.evento = evento;
      this.$refs.confirmDialog.open();
    },
    cancelarAlteracaoStatus() {
      this.evento.indAtivo = !this.evento.indAtivo;
    },
    alterarStatus() {
      const params = {
        id: this.evento.id,
        status: this.evento.indAtivo,
      };
      this.resources.ativarInativar(params, params).then(() => {
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }, (err) => {
        this.cancelarAlteracaoStatus();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length ||
        this.isDataValida(this.mesAnoPesquisa)) {
        this.esperar = true;
        setTimeout(() => {
          this.buscar();
        }, 5E2);
      }
    },
    editItem(item) {
      this.$emit('edit', item.id);
    },
    buscar() {
      const params = {
        nome: this.search,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.descending,
        indCancelado: this.indCancelado,
        colunaOrdenacao: this.pagination.sortBy,
        dataInicio: this.getDataInicio(),
        dataFim: this.getDataFim(),
      };

      this.resources.listar(params).then((response) => {
        this.eventos = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    getDataInicio() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'MM-YYYY').startOf(1).format('YYYY-MM-DD');
    },
    getDataFim() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'MM-YYYY').endOf('month').format('YYYY-MM-DD');
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
  },
  beforeMount() {
    if (!this.somenteLeitura) {
      this.headers.push({ text: '', value: 'acao', sortable: false });
    }
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/calendario/CalendarioTabela.vue?vue&type=script&lang=js&